export const HomeStyles = {
  SalesGridMini: {
    padding: 10,
    // cursor: "pointer",
  },
};
